module.exports = __webpack_public_path__ + "img/指标区.jpg";